/* eslint-disable */

import { useState, useContext } from "react";
import { Context } from "../../App";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { db } from "../../config/firebase";
import { doc, getDoc, deleteDoc, updateDoc } from 'firebase/firestore';

import { RxCaretSort } from "react-icons/rx";
import { RxCross2 } from "react-icons/rx";
import { FiSearch } from "react-icons/fi";

import IndividualUser from "./components/IndividualUser";
import ReactGA from "react-ga4";
import LeftBarAnimation from "../../components/animations/SideBarAnimation";

const UsersLIst = ({ groupsData, getChats }) => {
  const location = useLocation();

  const { showUsersContext,
    showMediaContext, } = useContext(Context);
  const [showUsers, setShowUsers] = showUsersContext;
  const [showMedia, setShowMedia] = showMediaContext;

  const leftIn = {
    hidden: {
      x: "-190px",
      opacity: 0,
    },
    visible: {
      x: "0",
      opacity: 1,
      transition: {
        duration: 0.15,
        type: "spring",
        damping: 30,
        stiffness: 500,
        // type: "linear",
      },
    },
    exit: {
      x: "-190px",
      opacity: 0,
    },
  };
  const [chatUsers, setChatUsers] = groupsData;

  const setChatUserNameCustom = (name) => {
    // setChatUserName(name)
  }

  const [currUserTab, setCurrUserTab] = useState({
    name: "Group"
  })
  const [userTab, setUserTab] = useState([{
    name: "Group"
  },
  {
    name: "Individual"
  }])

  const [percentFilter, setpercentFilter] = useState(false);
  const [timeFilter, setTimeFilter] = useState(false);
  const [search, setSearch] = useState("");

  // console.log(chatUsers);

  const setPinned = (groupId) => {


    setChatUsers((prev) => {
      let copy = prev.map((item) => {
        if (item.groupId === groupId) {

          updatePinnedGroup(groupId, !item.isPinned)
          return { ...item, isPinned: !item.isPinned }
        }
        return item
      });
      return copy;
    })
  }

  const updatePinnedGroup = async (groupId, isPinned) => {

    const docRef = doc(db, 'users', localStorage.getItem('uid'));

    try {
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        // console.log(docSnap.data().groups);
        let prevUserData = docSnap.data();
        let newGroups = prevUserData.groups.map((item) => {
          if (item.groupId === groupId) return {
            ...item,
            isPinned,
          }
          else return item
        })

        prevUserData.groups = newGroups;

        await updateDoc(docRef, prevUserData);
        // console.log("Document successfully Edited: ", prevUserData);
      } else {
        // console.log("DNE: ",);
      }

    } catch (error) {
      // console.error("Error adding document: ", error);
    }
  };

  return (
    <LeftBarAnimation showDiv={showUsers} variants={leftIn} overlayDirection={"left"}  >
      <div className={`flex w-full h-full flex-col`}>

        <div className="w-full justify-end">
          <div className="flex justify-evenly w-full">
            {userTab.map((item, i) => (
              <button
                style={{ "zIndex": currUserTab.name === item.name ? 0 : 10 }}
                key={item.name+"tabs-----"}
                className={`px-1 py-1 text-xs w-1/2 md:text-sm uppercase items-center dark:!bg-navyDL dark:shadow-none 
                            ${currUserTab.name === item.name ? "text-gray-800 hover:text-gray-700 bg-white dark:text-white " : "text-gray-600 hover:text-gray-700 bg-gray-50"}`}
                onClick={() => { setCurrUserTab(userTab[i]) }}>
                <div className="inline">{item.name}</div>
              </button>

            ))}

          </div>
        </div>

        <div style={{
          "position": "relative",
          "top": "-1px"
        }} className="flex flex-col h-[calc(100%-26px)] w-full border-t border-headPrimary bg-white dark:bg-navyDL">

          <div className="filterbar p-1">
            <div className="mb-2 gap-5 bg-white uppercase dark:!bg-navy-800">

              <div className="mt-2 w-full flex justify-between">
                <div className="ml-1 w-[49%] flex h-[19px] items-center rounded-sm bg-lightPrimary text-navy-700 dark:bg-navy-900 dark:text-white">
                  <p className="px-1">
                    <FiSearch className="h-3 w-3 text-gray-400 dark:text-white" />
                  </p>
                  <input
                    type="text"
                    placeholder="Search..."
                    className="block h-full w-full bg-lightPrimary text-xs font-medium text-navy-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />

                  <p
                    onClick={() => (setSearch(""))}
                    className="pl-1 pb-0.5 pr-1 text-xl">
                    <RxCross2 className="cursor-pointer h-3 w-3 text-gray-400 hover:text-gray-800 dark:text-white" />
                  </p>

                </div>

                <div className={`flex items-center ${percentFilter ? "text-gray-800 dark:text-white" : "text-gray-400 hover:text-gray-700"
                  }  `}
                  onClick={() => {
                    setpercentFilter((prev) => (!prev));
                  }}>
                  <p className="relative cursor-pointer text-xs">%&nbsp;</p>
                  <RxCaretSort />
                </div>

                <div className={`flex items-center ${timeFilter ? "text-gray-800 dark:text-white" : "text-gray-400 hover:text-gray-700"
                  }  `}
                  onClick={() => {
                    setTimeFilter((prev) => (!prev));
                  }}>
                  <p className="relative cursor-pointer text-xs">Time&nbsp;</p>
                  <RxCaretSort />
                </div>
              </div>

            </div>
          </div>
          <hr />

          <div className=" h-[calc(100%-44px)] overflow-y-auto">

            <table className="w-full">
              <tbody className="cursor-pointer text-gray-500">

                {currUserTab.name === "Group" ?
                  <>
                    {chatUsers.sort(function (a, b) {  //default sort /by selected then /by name
                      if (a.isPinned && !b.isPinned) {
                        return -1;
                      }
                      else if (!a.isPinned && b.isPinned) {
                        return 1;
                      }
                      else {
                        if (a.name <= b.name) { return -1; }
                        if (a.name > b.name) { return 1; }
                      }
                    }).filter((item) => (!item.isIndividual &&
                      (search === "" || item.name.toLowerCase().includes(search.toLowerCase()) || item.groupId.toLowerCase().includes(search.toLowerCase()))))
                      .map((item, i) => (
                        < IndividualUser item={item} setPinned={setPinned} getChats={getChats} />
                      ))}

                  </>
                  : <>
                    {chatUsers.sort(function (a, b) {  //default sort /by selected then /by name
                      if (a.isPinned && !b.isPinned) {
                        return -1;
                      }
                      else if (!a.isPinned && b.isPinned) {
                        return 1;
                      }
                      else {
                        if (a.name <= b.name) { return -1; }
                        if (a.name > b.name) { return 1; }
                      }
                    }).filter((item) => (item.isIndividual &&
                      (search === "" || item.name.toLowerCase().includes(search.toLowerCase()) || item.groupId.toLowerCase().includes(search.toLowerCase()))))
                      .map((item, i) => (
                        < IndividualUser item={item} setPinned={setPinned} i={i} setChatUserName={setChatUserNameCustom} getChats={getChats} />
                      ))}

                  </>
                }

              </tbody>
            </table>

          </div>

        </div>
      </div>
    </LeftBarAnimation>
  );
};

export default UsersLIst;
